module.exports = __webpack_public_path__ + "media/images/icons/marker-867a211cc941ebc99e81f0e29d5cb55a.png";